<template>
  <v-app id="inspire">
    <v-navigation-drawer
            v-model="drawer"
            :clipped="$vuetify.breakpoint.lgAndUp"
            app
    >
      <v-list dense>
        <template v-for="item in menus">
          <v-layout
                  v-if="item.heading"
                  :key="item.heading"
                  row
                  align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex
                    xs6
                    class="text-xs-center"
            >
              <a
                      href="#!"
                      class="body-2 black--text"
              >EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
                  v-else-if="item.children"
                  :key="item.text"
                  v-model="item.model"
                  :prepend-icon="item.model ? item.icon : item['icon-alt']"
                  append-icon=""
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
                    v-for="(child, i) in item.children"
                    :key="i"
                    @click=""
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
                  v-else
                  :key="item.text"
                  @click=""
                  :to="item.url"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            color="blue darken-3"
            dark
    >
      <v-toolbar-title
              style="width: 300px"
              class="ml-0 pl-3"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Sakarya Destech Bilişim  </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text color="white" >
          {{$store.getters.adSoyad}}
      </v-btn>
      <v-btn text icon color="white" @click="logout">
          <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <div style="padding: 5px">
        <router-view/>
      </div>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name:"index",
    data: () => ({
      dialog: false,
      drawer: null,
      menus: [],
    }),
    created () {
          this.initialize()
    },
    methods:{
      navigate(event,item){
        console.log("navigate",event);
        console.log("navigate",item);
      },
      logout(){
        let response = confirm("Çıkış yapmak istediğinize emin misiniz ?")
        if(response){
          window.localStorage.removeItem("app-token");
          location.reload();
        }
      },
      initialize () {
          this.$axios.get("menu").then(response=>{
                this.menus = response.data;
                //console.log(this.menus);
          });
              //this.items = []
      },
    }
  }
</script>
